import { Locale } from "src/lib/Intl";
import i18nRoutes from "./i18nRoutes";

interface i18RouteProps {
  route: string;
  locale: Locale;
}

interface Routes {
  [key: string]: {
    [key: string]: string | null;
  };
}

const getI18nRoute = ({ route, locale }: i18RouteProps): string => {
  if ((i18nRoutes as Routes)?.[route]?.[locale]) {
    return (i18nRoutes as Routes)[route][locale] as string;
  }

  return route;
};

export { getI18nRoute };
